import { Location } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Injectable, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { BackendAPI } from '@core/models/backend-api';
import { map, Observable } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class StaticResourceService {

	constructor (
		private http: HttpClient,
		private sanitizer: DomSanitizer) { }

	getBrandingPackageInfoById(packageId: string): Observable<string | undefined> {

		const packageInfoFile = `${packageId}.html`;
		const url = Location.joinWithSlash(BackendAPI.staticResourcePackageInfopanel, packageInfoFile);

		return this.http.get(url, { responseType: 'text' }).pipe(
			map((val) => this.sanitizer.sanitize(SecurityContext.HTML, val) || undefined)
		);
	}
}
